module.exports = __webpack_public_path__ + "img/123.e6d3cc72.jpg";